"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * SimulationStringConverter.
 *
 * @author BPo
 */


var SimulationStringConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SimulationStringConverter, _DataObjectConverter_);

  function SimulationStringConverter() {
    _classCallCheck(this, SimulationStringConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulationStringConverter).apply(this, arguments));
  }

  return SimulationStringConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SimulationStringConverter = SimulationStringConverter;